module.exports = __webpack_public_path__ + "media/shard_blogs/techmoon-49361155.png";